import React from 'react';
import PropTypes from 'prop-types';
import SelectedChargingStationCard from '../SelectedChargingStationCard/SelectedChargingStationCard';
import ChargingStationsMapLegend from '../ChargingStationsMapLegend/ChargingStationsMapLegend';

import './MapControlPanel.scss';

const MapControlPanel = ({
  mobile,
  chargingStations,
  children,
  selectedStation,
  toggleWithHistory,
  route
}) => {

  return (
    <div className="MapControlPanel">
      {(chargingStations || []).length > 0 && (
        <>
          <ChargingStationsMapLegend
            chargingStations={chargingStations}
            mobile={mobile}
          />
        </>
      )}
      <SelectedChargingStationCard
        toggleWithHistory={toggleWithHistory}
        station={selectedStation}
        route={route}
      />
      <div className={`${mobile ? 'row' : 'col'} map-controls`}>{children}</div>
    </div>
  );
};

MapControlPanel.propTypes = {
  chargingStations: PropTypes.array,
  children: PropTypes.node,
  selectedStation: PropTypes.object,
};

MapControlPanel.defaultProps = {
  chargingStations: [],
};

export default MapControlPanel;
